import { Circle, Flex } from '@chakra-ui/react';

export const AdvantageCard = ({ icon, content, color }) => (
  <Flex
    alignItems="center"
    p={{ base: 4, xl: 6 }}
    borderColor="gray.100"
    borderWidth="1px"
    borderRadius="8px"
    flex={1}
  >
    <Flex>
      <Circle bg={color} size="65px">
        {icon}
      </Circle>
    </Flex>
    <Flex flex={1} flexDir="column" pl={{ base: 4, xl: 8 }}>
      {content}
    </Flex>
  </Flex>
);
